import script from "./manage.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage.vue?vue&type=script&lang=ts&setup=true"

import "./manage.vue?vue&type=style&index=0&id=a62652e6&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a62652e6"]])

export default __exports__